import { render, staticRenderFns } from "./HomeContactUs.vue?vue&type=template&id=0af171c0&"
import script from "./HomeContactUs.ts?vue&type=script&lang=ts&"
export * from "./HomeContactUs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports